import { t } from 'i18next';

import { ErrorResponseErrorItemCodeProject } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeProject, string> = {
  'project:folder_name_exists':
    t('project.folderNameExists', { ns: 'apiErrorCodes' }) ??
    'En mapp med samma namn existerar redan.',
  'project:not_found': 'Projektet kunde inte hittas.',
  'project:invalid_status': 'Projektet har inte förväntad status.',
  'project:user_unauthorized': 'Du har inte åtkomst till aktuellt projekt.',
  'project:coordinate_system_not_found': 'Projektet saknar koordinatsystem.',
  'project:geoid_not_found': 'Projektet saknar geoid.',
  'project:not_archived': 'Projektet är inte arkiverat.',
  'project:no_restorable_archive_job_exists':
    'Det finns inget färdigt arkiveringsjobb att återställa.',
  'project:create_real_property_error': 'Ett oväntat fel uppstod vid inköp av fastighetsgräns.',
  'project:create_real_property_timeout': 'Ett oväntat fel uppstod vid inköp av fastighetsgräns.',
  'project:get_real_properties_error': 'Ett oväntat fel uppstod vid sökning av fastigheter.',
  'project:get_real_properties_timeout': 'Ett oväntat fel instod vid sökning av fastigheter.',
  'project:archive_job_not_found': 'Arkiveringsjobb kunde inte hittas.',
  'project:current_archive_job_exists': 'Ett aktuellt arkiveringsjobb existerar.',
  'project:current_restore_job_exists': 'Ett aktuellt återställningsjobb existerar.',
  'project:archive_job_cannot_be_deleted': 'Arkiveringsjobbet kan inte tas bort.',
  'project:no_permission_to_set_archive_date': 'Du saknar rättigheter att ange arkiveringsdatum.',
  'project:no_permission_to_add_archive_job': 'Du saknar rättigheter att arkivera projektet.',
  'project:no_registered_dongles_exist': 'Inga registrerade enheter existerar.',
  'project:has_no_drone_harmony_integration': 'En integration för Drone Harmony saknas.',
  'project:drone_harmony_integration_already_exists':
    'En integration för Drone Harmony existerar redan.',
  'project:drone_harmony_flight_plan_not_found':
    'Flygrutten för Drone Harmony integrationen kunde inte hittas.',
  'project:drone_harmony_no_access_to_flight_plan':
    'Flygrutten för Drone Harmony kan inte kopplas då integrationsansvarig inte äger den angivna flygrutten.',
};
